module.exports = {
    cache: require("./cache"),
    eachCombination: require("./eachCombination")
};